import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ListConfig } from '@app/models/shared.model'
import { EventsService } from '@app/modules/culture/events/services/events.service'
import { AuthService } from '@app/core/auth/services/auth.service'
import { allPermissions } from '@app/core/auth/permissions'
import { take } from 'rxjs'

@Component({selector: 'app-generate-report-modal',
  templateUrl: './generate-report-modal.component.html',
  styleUrls: ['./generate-report-modal.component.scss'],
  standalone: false,
})
export class GenerateReportModalComponent {
  /** Form group */
  @Input() form: FormGroup

  /** Generate report button on click output */
  @Output() generateReportOnClick = new EventEmitter<any>()

  /** The report type dropdown value change output */
  @Output() reportTypeChange = new EventEmitter<any>()

  /** Report types list config */
  reportTypesList: ListConfig = new ListConfig({
    data: [],
    filter: false,
    template: 'translated',
    translatePrevLabel: 'REPORTS.TYPE.',
  })

  constructor(
    private eventService: EventsService,
    private authService: AuthService,
  ) {
    this.eventService
      .getCategories()
      .pipe(take(1))
      .subscribe((eventTypes: any) => {
        const reports = eventTypes[0].reports
        this.reportTypesList.data = reports ? reports.filter((report: string) => this.canSeeReport(report)) : reports
      })
  }

  /** The vehicle and HME reports follow their pages: shown exactly to the users the sidebar shows
   *  Vehicles / HME to (both pages are gated on the `vehicles` permission). The report list itself
   *  is one shared event_types row, the same for every client and user. */
  private canSeeReport(report: string): boolean {
    if (report === 'vehiclesActivityReport' || report === 'hmeActivityReport') return !!this.authService.hasPermission(allPermissions.vehicles.name)
    return true
  }

  /**
   * Generate report button on click emt output
   * @param e For prevent default
   */
  onGenerate(e: Event) {
    e.preventDefault()
    this.generateReportOnClick.emit()
  }
}
